/**
 * Adds '+' prefix to a phone number or string if it doesn't already contain '+'.
 * Also handles international '00' prefix if present.
 *
 * @param {string|number} phone - Phone number to format
 * @returns {string} Formatted phone number with '+'
 */
export function addPlusToPhoneNumber(phone) {
    if (!phone && phone !== 0) return '';
    const phoneStr = String(phone).trim();
    if (!phoneStr) return '';
    if (phoneStr.includes('+')) {
        return phoneStr;
    }
    if (phoneStr.startsWith('00')) {
        return `+${phoneStr.slice(2)}`;
    }
    return `+${phoneStr}`;
}

export const formatPhoneNumber = addPlusToPhoneNumber;
export const AddPlusToString = addPlusToPhoneNumber;
export default addPlusToPhoneNumber;

